import * as React from "react";
import {Types}    from "@Common/types";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load}             from "@Common/react/load";
import {UseState}         from "@Common/react/use-state";
import {SearchableSelect} from "@Common/ui-components/searchable-select/searchable-select";
import {sortMulti}        from "@Common/utils/collections";
import {chain}            from "@Common/utils/fs";
import {equalDeep, omit}  from "@Common/utils/objects";

import './officeSearchField.scss';


export const OfficeSearchField = ({ onlyOffice = false, labelname, value, xdQAType, xdQAValue, data, contentGroup, displayGroup, setBranchIsInternational, fieldKey = '' }) => cs(

    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    consumeContext("company"),

    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["managing", (_, next) => UseState({next})],
    ["state", ({session}, next) => UseState({
        defaultValue: session.value,
        next,
    })],
    ["branchList", ({apis}, next) => Load({
        fetch: async () => {
            let branchList;
            if (onlyOffice)  {
                branchList = await apis.next.getBranchList({filterByUserLevel: false});
                // TODO: Optimize this logic. Look for a more efficient approach to handle the operation below.
                fieldKey !== '' && branchList.forEach(branch => branch.fieldKey =  fieldKey);
                return branchList;
            } else {
                branchList = null;
            }
            return branchList;
        },
        next,
    })],

    ({state, session, forcedBranchId, isInternalUser, branchList}) =>

            <div className="office-search-field-47j">
                <div className="form">
                    {(onlyOffice) && (
                        <div className="form-group">

                            {SearchableSelect({
                                getSublabel: (branch) => (<>
                                    <div>
                                        {[
                                            branch.branchAddress1,
                                            branch.branchAddress2,
                                            branch.branchCity,
                                            branch.branchState,
                                            branch.branchZip,
                                        ].filter(Boolean).join(", ")}
                                    </div>
                                    <div
                                        xd-qa-type="dropdown_item"
                                        xd-qa-name={`Office ${branch.idBranch}`}
                                    >
                                        {branch.branchLinkId} {isInternalUser && `| Internal ID: ${branch.idBranch}`}
                                    </div>
                                </>),
                                list: chain(
                                    branchList ?? (session.data.branchName ? [{idBranch: session.value.branchId, branchName: session.data.branchName}] : []),
                                    (_) => sortMulti(_, [
                                        (branch) => branch["branchName"]?.toLowerCase(),
                                    ]),
                                ),
                                loading: !branchList,
                                placeholder: "Search for an office",
                                getLabel: (branch) => chain(
                                    branch.branchName || branch.branchLinkId,
                                    (label) => <span title={label} xd-qa-type="dropdown_item" xd-qa-name={`Office ${label}`}>{label}</span>
                                ),
                                mapSearchAsItemFilter: (search:string) => {
                                    const searchLowercase = search.toLowerCase();
                                    return (branch) => (isInternalUser && branch.idBranch.includes(searchLowercase)) || [
                                        "branchName",
                                        "branchLinkId",
                                        "branchAddress1",
                                        "branchAddress2",
                                        "branchCity",
                                        "branchState",
                                    ].some(field => branch[field].toLowerCase().includes(searchLowercase))
                                },
                                onSelect: async (branch) => {
                                    setBranchIsInternational(!['United States','US','USA','Canada','CA'].includes(branch.branchCountry));

                                    // Generate branchLabelsValuesMap dynamically
                                    const branchLabelsValuesMap = {
                                        "{{branch:branch_display_1}}": branch.branchDisplay1,
                                        "{{branch:branch_display_2}}": branch.branchDisplay2,
                                        "{{branch:branch_display_3}}": branch.branchDisplay3,
                                        "{{branch:branch_display_4}}": branch.branchDisplay4,
                                        "{{branch:branch_display_5}}": branch.branchDisplay5,
                                        "{{branch:branch_display_6}}": branch.branchDisplay6,
                                        "{{branch:branch_display_custom1}}": branch.branchDisplayCustom1,
                                        "{{branch:branch_display_custom2}}": branch.branchDisplayCustom2,
                                        "{{branch:branch_phone_1}}": branch.branchPhone1,
                                        "{{branch:branch_phone_2}}": branch.branchPhone2,
                                        "{{branch:branch_fax}}": branch.branchFax,
                                    }
                                    let countOfficeSearchFields = 0;

                                    // Check if there are multiple office search fields in the template
                                    for (const field of data) {
                                        if (field.idDisplayStyle === 9) {
                                            countOfficeSearchFields++;
                                            // Use fieldKey to find and update the correct field
                                            const targetField = data.find(f => f.fieldKey === branch.fieldKey);
                                            if (targetField) {
                                                // update the Office Search field
                                                targetField?.onChange(branch.idBranch);
                                            }
                                        }
                                    }
                                    //  changing values of other fields based on binding
                                    for (const label in branchLabelsValuesMap) {
                                        if (countOfficeSearchFields > 1) {
                                            data.find(field => (field.defaultValue === label && field.contentGroup === contentGroup && field.displayGroup === displayGroup))?.onChange(branchLabelsValuesMap[label]);
                                        }
                                        else {
                                            data.find(field => (field.defaultValue === label && field.contentGroup === contentGroup))?.onChange(branchLabelsValuesMap[label]);
                                        }
                                    }

                                    state.onChange(!branch ? {} : {
                                        branchId: branch.idBranch,
                                    });

                                },
                                isSelected: (branch) => value === branch.idBranch,

                                className: "office",
                                searchLabel: "Search an Office",
                                xdQaName: "Office",
                                scrollCloses: false,
                            })}
                        </div>
                    )}

                </div>


                {!equalDeep(
                    {
                        ...state.value,
                        ...forcedBranchId && {branchId: forcedBranchId},
                    },
                    session.value
                )}
            </div>


);
